module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', [_vm._v("\n            " + _vm._s(_vm.$route.name) + " - " + _vm._s(_vm.form.enquiry_no) + " - Booking NO -" + _vm._s(_vm.form.enquiry_booking_no) + "\n          ")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("ENQUIRY NO."), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": true,
      "required": ""
    },
    model: {
      value: (_vm.form.enquiry_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "enquiry_no", $$v)
      },
      expression: "form.enquiry_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n            Shipment Type\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.shipment_type && _vm.errorList.shipment_type ? 'red' : '',
    }),
    attrs: {
      "list": _vm.shipment_typeList,
      "id": "shipment_type",
      "isDisabled": true,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Please Select Shipment Type"
    },
    model: {
      value: (_vm.form.shipment_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipment_type", $$v)
      },
      expression: "form.shipment_type"
    }
  }), _vm._v(" "), (!_vm.form.shipment_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.shipment_type) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n            Transport Type \n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.transport_type && _vm.errorList.transport_type ? 'red' : '',
    }),
    attrs: {
      "list": _vm.moduelTypeList,
      "isDisabled": true,
      "id": "transport_type",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Please Select Transport Type"
    },
    model: {
      value: (_vm.form.transport_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "transport_type", $$v)
      },
      expression: "form.transport_type"
    }
  }), _vm._v(" "), (!_vm.form.transport_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.transport_type) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("INCO TERM SHIPMENT TERM"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.inco_term && _vm.errorList.inco_term ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.deliveryTermsList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Incoterm",
      "required": ""
    },
    model: {
      value: (_vm.form.inco_term),
      callback: function($$v) {
        _vm.$set(_vm.form, "inco_term", $$v)
      },
      expression: "form.inco_term"
    }
  }), _vm._v(" "), (!_vm.form.inco_term) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.inco_term) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SHIPPER"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_client_id && _vm.errorList.fk_client_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.shipment_type == '' || _vm.form.transport_type == '' || _vm.form.fk_client_id || _vm.form.prbr_id > 0 ?
        true :
        false,
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select SHIPPER",
      "required": ""
    },
    model: {
      value: (_vm.form.fk_client_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_client_id", $$v)
      },
      expression: "form.fk_client_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_client_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_client_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("EMPTY PICK UP"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_epk_id && _vm.errorList.fk_epk_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.shipment_type == '' || _vm.form.transport_type == '' || _vm.form.prbr_id > 0 ? true :
        false,
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'Export' ?
        _vm.$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    model: {
      value: (_vm.form.fk_epk_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_epk_id", $$v)
      },
      expression: "form.fk_epk_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_epk_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_epk_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("HANDOVER"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_por_id && _vm.errorList.fk_por_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.shipment_type == '' || _vm.form.transport_type == '' || _vm.form.fk_por_id || _vm.form.prbr_id > 0 ?
        true :
        false,
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'Export' ?
        _vm.$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    model: {
      value: (_vm.form.fk_por_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_por_id", $$v)
      },
      expression: "form.fk_por_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_por_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_por_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_pol_id && _vm.errorList.fk_pol_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.shipment_type == '' || _vm.form.transport_type == '' || _vm.form.fk_pol_id || _vm.form.prbr_id > 0 ?
        true :
        false,
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'Export' ?
        _vm.$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    model: {
      value: (_vm.form.fk_pol_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_pol_id", $$v)
      },
      expression: "form.fk_pol_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_pol_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_pol_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_pod_id && _vm.errorList.fk_pod_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.shipment_type == '' || _vm.form.transport_type == '' || _vm.form.fk_pod_id || _vm.form.prbr_id > 0 ?
        true :
        false,
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'Export' ?
        _vm.$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "location",
      "placeholder": "Select POD"
    },
    model: {
      value: (_vm.form.fk_pod_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_pod_id", $$v)
      },
      expression: "form.fk_pod_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_pod_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_pod_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FINAL DESTINATION"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_fpod_id && _vm.errorList.fk_fpod_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.shipment_type == '' || _vm.form.transport_type == '' || _vm.form.fk_fpod_id || _vm.form.prbr_id > 0 ?
        true :
        false,
      "list": _vm.form.transport_type == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.form.transport_type == 'Export' ?
        _vm.$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "location",
      "placeholder": "Select POD"
    },
    model: {
      value: (_vm.form.fk_fpod_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_fpod_id", $$v)
      },
      expression: "form.fk_fpod_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_fpod_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_fpod_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("EQUIPMENT"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_container_id && _vm.errorList.fk_container_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.form.fk_container_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_container_id", $$v)
      },
      expression: "form.fk_container_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_container_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_container_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.commodity_type && _vm.errorList.commodity_type ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.commodityTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.form.commodity_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "commodity_type", $$v)
      },
      expression: "form.commodity_type"
    }
  }), _vm._v(" "), (!_vm.form.commodity_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.commodity_type) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.form.commodity_type == 'Hazardous') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "imdg_class"
    }
  }, [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.imdg_class && _vm.errorList.imdg_class ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "formatter": _vm.capitalizeAll,
      "id": "imdg_class",
      "name": "imdg_class"
    },
    model: {
      value: (_vm.form.imdg_class),
      callback: function($$v) {
        _vm.$set(_vm.form, "imdg_class", $$v)
      },
      expression: "form.imdg_class"
    }
  }), _vm._v(" "), (!_vm.form.imdg_class) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.imdg_class) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Hazardous') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "un_number"
    }
  }, [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.un_number && _vm.errorList.un_number ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "formatter": _vm.capitalizeAll,
      "id": "un_number",
      "name": "un_number"
    },
    model: {
      value: (_vm.form.un_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "un_number", $$v)
      },
      expression: "form.un_number"
    }
  }), _vm._v(" "), (!_vm.form.un_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.un_number) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Hazardous') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "packing_code"
    }
  }, [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.packing_code && _vm.errorList.packing_code ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "formatter": _vm.capitalizeAll,
      "id": "packing_code",
      "name": "packing_code"
    },
    model: {
      value: (_vm.form.packing_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "packing_code", $$v)
      },
      expression: "form.packing_code"
    }
  }), _vm._v(" "), (!_vm.form.packing_code) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.packing_code) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Reefer') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "temperature_required"
    }
  }, [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.temperature_required && _vm.errorList.temperature_required ?
        'red' :
        '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "formatter": _vm.capitalizeAll,
      "id": "temperature_required",
      "name": "temperature_required"
    },
    model: {
      value: (_vm.form.temperature_required),
      callback: function($$v) {
        _vm.$set(_vm.form, "temperature_required", $$v)
      },
      expression: "form.temperature_required"
    }
  }), _vm._v(" "), (!_vm.form.temperature_required) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.temperature_required) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.commodity_type == 'Others') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "other_comodity"
    }
  }, [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.form.other_comodity && _vm.errorList.other_comodity ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "formatter": _vm.capitalizeAll,
      "id": "other_comodity",
      "name": "other_comodity"
    },
    model: {
      value: (_vm.form.other_comodity),
      callback: function($$v) {
        _vm.$set(_vm.form, "other_comodity", $$v)
      },
      expression: "form.other_comodity"
    }
  }), _vm._v(" "), (!_vm.form.other_comodity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.other_comodity) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("COMMODITY & HS CODE"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_commodity_id && _vm.errorList.fk_commodity_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemHSNCode",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'getCommodityData')
      }
    },
    model: {
      value: (_vm.form.fk_commodity_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_commodity_id", $$v)
      },
      expression: "form.fk_commodity_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_commodity_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_commodity_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openCommodityModal()
      }
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("HUMIDITY (for reefer)"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.humidity && _vm.errorList.humidity ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "required": ""
    },
    model: {
      value: (_vm.form.humidity),
      callback: function($$v) {
        _vm.$set(_vm.form, "humidity", $$v)
      },
      expression: "form.humidity"
    }
  }), _vm._v(" "), (!_vm.form.humidity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.humidity) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("CARGO WEIGHT"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.cargo_weight && _vm.errorList.cargo_weight ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0
    },
    model: {
      value: (_vm.form.cargo_weight),
      callback: function($$v) {
        _vm.$set(_vm.form, "cargo_weight", $$v)
      },
      expression: "form.cargo_weight"
    }
  }), _vm._v(" "), (!_vm.form.cargo_weight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.cargo_weight) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SHIPPING LINE"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_shipping_id && _vm.errorList.fk_shipping_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.form.fk_shipping_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_shipping_id", $$v)
      },
      expression: "form.fk_shipping_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_shipping_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_shipping_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SPOT NON SPOT"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.spot_non_spot && _vm.errorList.spot_non_spot ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.spotList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Spot Non-Spot"
    },
    model: {
      value: (_vm.form.spot_non_spot),
      callback: function($$v) {
        _vm.$set(_vm.form, "spot_non_spot", $$v)
      },
      expression: "form.spot_non_spot"
    }
  }), _vm._v(" "), (!_vm.form.spot_non_spot) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.spot_non_spot) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("RA NUMBER"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.ra_number && _vm.errorList.ra_number ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "type": "text"
    },
    model: {
      value: (_vm.form.ra_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "ra_number", $$v)
      },
      expression: "form.ra_number"
    }
  }), _vm._v(" "), (!_vm.form.ra_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.ra_number) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("RATE AGREED"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.rate_agreed && _vm.errorList.rate_agreed ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "type": "number"
    },
    model: {
      value: (_vm.form.rate_agreed),
      callback: function($$v) {
        _vm.$set(_vm.form, "rate_agreed", $$v)
      },
      expression: "form.rate_agreed"
    }
  }), _vm._v(" "), (!_vm.form.rate_agreed) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.rate_agreed) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("\n            Currency\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.fk_currency_id && _vm.errorList.fk_currency_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.$store.getters['common/getAllCurrencyList'],
      "option-value": "currency_id",
      "option-text": "currencyCode",
      "placeholder": "Select Currency"
    },
    on: {
      "input": function($event) {
        _vm.getCurrencyName(_vm.form.fk_currency_id)
      }
    },
    model: {
      value: (_vm.form.fk_currency_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_currency_id", $$v)
      },
      expression: "form.fk_currency_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_currency_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_currency_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FREE DAYS"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.free_days && _vm.errorList.free_days ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "type": "text"
    },
    model: {
      value: (_vm.form.free_days),
      callback: function($$v) {
        _vm.$set(_vm.form, "free_days", $$v)
      },
      expression: "form.free_days"
    }
  }), _vm._v(" "), (!_vm.form.free_days) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.free_days) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("PDA"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.pda && _vm.errorList.pda ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.pdaList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select PDA"
    },
    model: {
      value: (_vm.form.pda),
      callback: function($$v) {
        _vm.$set(_vm.form, "pda", $$v)
      },
      expression: "form.pda"
    }
  }), _vm._v(" "), (!_vm.form.pda) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.pda) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("ETD"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.etd && _vm.errorList.etd ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.prbr_id > 0,
      "type": "date"
    },
    model: {
      value: (_vm.form.etd),
      callback: function($$v) {
        _vm.$set(_vm.form, "etd", $$v)
      },
      expression: "form.etd"
    }
  }), _vm._v(" "), (!_vm.form.etd) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.etd) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BL INSTRUCTION"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.form.bl_instruction && _vm.errorList.bl_instruction ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.blINSTRUCTIONList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select BL INSTRUCTION"
    },
    model: {
      value: (_vm.form.bl_instruction),
      callback: function($$v) {
        _vm.$set(_vm.form, "bl_instruction", $$v)
      },
      expression: "form.bl_instruction"
    }
  }), _vm._v(" "), (!_vm.form.bl_instruction) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.bl_instruction) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("AGENT"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_agent_id && _vm.errorList.fk_agent_id ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.prbr_id > 0,
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select AGENT"
    },
    model: {
      value: (_vm.form.fk_agent_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_agent_id", $$v)
      },
      expression: "form.fk_agent_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_agent_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.fk_agent_id) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("REMARKS (if any)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": _vm.form.prbr_id > 0
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mx-auto text-center",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n            Back\n          ")]), _vm._v(" "), (_vm.form.prbr_id <= 0) ? _c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.saveBookingResp
    }
  }, [_vm._v("\n            Save\n          ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Commodity-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Commodity"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.commodityModal.itemName && _vm.errorComodityList.itemName ? 'red' : '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName"
    },
    model: {
      value: (_vm.commodityModal.itemName),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "itemName", $$v)
      },
      expression: "commodityModal.itemName"
    }
  }), _vm._v(" "), (!_vm.commodityModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorComodityList.itemName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("HSN Code "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.commodityModal.hsnCode && _vm.errorComodityList.hsnCode ? 'red' : '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "hsnCode",
      "name": "hsnCode"
    },
    model: {
      value: (_vm.commodityModal.hsnCode),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "hsnCode", $$v)
      },
      expression: "commodityModal.hsnCode"
    }
  }), _vm._v(" "), (!_vm.commodityModal.hsnCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorComodityList.hsnCode))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.commodityDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addCommodity
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideCommodityModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c3e00b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/addBookingResp.vue
// module id = 2411
// module chunks = 0